import { render } from "./tabnav.vue?vue&type=template&id=034c15d6&scoped=true"
import script from "./tabnav.vue?vue&type=script&lang=js"
export * from "./tabnav.vue?vue&type=script&lang=js"

import "./tabnav.vue?vue&type=style&index=0&id=034c15d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034c15d6"]])

export default __exports__